import { type RawInlineNodes } from '@principle-theorem/editor';
import {
  AnyAutomation,
  AutomationType,
  IAutomatedFormIssue,
  isAutomatedFormIssue,
  isAutomatedNotification,
  isGeneratedTask,
  type IAutomatedNotification,
  type IAutomation,
  type IGeneratedTask,
} from '@principle-theorem/principle-core/interfaces';
import { type EntityModel, type Timestamp } from '@principle-theorem/shared';
import { omit } from 'lodash';

export type IAutomationWithMetadata = IAutomation<AnyAutomation> & {
  appointmentSummary?: string;
  patientMention?: RawInlineNodes;
};

export type AutomationEntity = EntityModel<IAutomationWithMetadata>;

export function getAutomationEntity(
  automation: AutomationEntity
): EntityModel<IAutomation<AnyAutomation>> {
  return omit(automation, [
    'patientMention',
    'appointmentSummary',
  ]) as EntityModel<IAutomation<AnyAutomation>>;
}

export function isGeneratedTaskAutomation(
  entity: AutomationEntity
): entity is EntityModel<IAutomation<IGeneratedTask>> {
  return (
    entity.type === AutomationType.GeneratedTask && isGeneratedTask(entity.data)
  );
}

export function isAutomatedNotificationAutomation(
  entity: AutomationEntity
): entity is EntityModel<IAutomation<IAutomatedNotification>> {
  return (
    entity.type === AutomationType.AutomatedNotification &&
    isAutomatedNotification(entity.data)
  );
}

export function isAutomatedFormIssueAutomation(
  entity: AutomationEntity
): entity is EntityModel<IAutomation<IAutomatedFormIssue>> {
  return (
    entity.type === AutomationType.AutomatedFormIssue &&
    isAutomatedFormIssue(entity.data)
  );
}

export interface IRescheduleListData {
  automation: AutomationEntity;
  autoCancelled: boolean;
  reschedule: boolean;
  newDate?: Timestamp;
  changes?: Partial<IAutomation<AnyAutomation>>;
}
